var styleDataHash = '1e613253';  
export const injectCss = (() => {
  var css = `@charset "UTF-8";.JUfrJ,.ReactModalPortal,.Xh03S,.glob_fontElementMap,button{font-family:var(--ricos-font-family,unset)}.LCUle{display:flex}.Cw6kn:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.Cw6kn:hover,.EaGE4{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}.EaGE4{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.lB1eW .EaGE4{box-shadow:none!important}.LDy8h{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.LDy8h.WFxJr{pointer-events:none}._6mGx6 ::selection{background:transparent}.OV--g{display:none}.Xh03S{position:relative}._54Mb-{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.fGmy-{color:#333;text-decoration:none}.lwl-U{display:block}.RQf9L{position:relative}.s2Z8N{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.s2Z8N.vuFg-::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.s2Z8N.NX6gd::-webkit-scrollbar-thumb{background-color:transparent}._7s-NQ{max-width:max-content!important;min-width:100%}.s2Z8N::-webkit-scrollbar{-webkit-appearance:none}.s2Z8N::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.s2Z8N::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "JUfrJ",
  "pluginContainer": "Xh03S",
  "flex": "LCUle",
  "isFocusable": "Cw6kn",
  "hasFocus": "EaGE4",
  "dragImageView": "lB1eW",
  "overlay": "LDy8h",
  "noPointerEventsOnFocus": "WFxJr",
  "hideTextSelection": "_6mGx6",
  "hidden": "OV--g",
  "pluginContainerMobile": "_54Mb-",
  "isImage": "fGmy-",
  "anchor": "lwl-U",
  "horizontalScrollbarWrapper": "RQf9L",
  "pluginWithHorizontalScrollbar": "s2Z8N",
  "show": "vuFg-",
  "hide": "NX6gd",
  "horizontalScrollbar": "_7s-NQ"
};